export const INSIGHTS_CARD_STATUS = {
  HIDDEN: 'hidden',
  UNPUBLISHED: 'unpublished',
  PUBLISHED: 'published'
};
